// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".analytics__title[data-v-4826fd97]{color:#036;text-align:center}", ""]);
// Exports
module.exports = exports;
